import React from "react";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from "@stripe/react-stripe-js";

import { Icon } from "./icons";

/**
 * Formulaire carte du design (numéro, titulaire, expiration, CVC).
 *
 * Numéro, expiration et CVC sont des champs Stripe Elements : ils vivent
 * dans des iframes de Stripe, la carte ne passe jamais par notre code ni
 * par notre serveur (PCI). Seul le nom du titulaire est un champ à nous.
 */

const ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#1B1F3A",
      fontFamily: "Manrope, -apple-system, system-ui, 'Segoe UI', sans-serif",
      fontSize: "16px",
      fontSmoothing: "antialiased",
      "::placeholder": { color: "#9499B8" },
    },
    invalid: { color: "#B91C1C", iconColor: "#B91C1C" },
  },
};

const CardForm = ({ t, holder, onHolder, onFieldChange, error }) => (
  <div className="wosh-rc__card-form">
    <div className="wosh-rc__card-field wosh-rc__card-field--wide">
      <span className="wosh-rc__label">{t("Card number")}</span>
      <div className="wosh-rc__input">
        <Icon name="card" />
        <CardNumberElement
          className="wosh-rc__stripe"
          options={{ ...ELEMENT_OPTIONS, placeholder: "1234 5678 9012 3456" }}
          onChange={(event) => onFieldChange("number", event)}
        />
      </div>
    </div>

    <label className="wosh-rc__card-field">
      <span className="wosh-rc__label">{t("Cardholder")}</span>
      <div className="wosh-rc__input">
        <input
          type="text"
          autoComplete="cc-name"
          value={holder}
          onChange={(event) => onHolder(event.target.value)}
          placeholder={t("Name on the card")}
        />
      </div>
    </label>

    <div className="wosh-rc__card-field">
      <span className="wosh-rc__label">{t("Expiry")}</span>
      <div className="wosh-rc__input">
        <CardExpiryElement
          className="wosh-rc__stripe"
          options={{ ...ELEMENT_OPTIONS, placeholder: t("MM / YY") }}
          onChange={(event) => onFieldChange("expiry", event)}
        />
      </div>
    </div>

    <div className="wosh-rc__card-field">
      <span className="wosh-rc__label">CVC</span>
      <div className="wosh-rc__input">
        <CardCvcElement
          className="wosh-rc__stripe"
          options={{ ...ELEMENT_OPTIONS, placeholder: "123" }}
          onChange={(event) => onFieldChange("cvc", event)}
        />
      </div>
    </div>

    {error && (
      <div className="wosh-rc__field-error wosh-rc__card-field--wide" role="alert">
        {error}
      </div>
    )}

    <div className="wosh-rc__card-note wosh-rc__card-field--wide">
      {t("The card is saved to your account for your next orders.")}
    </div>
  </div>
);

export default CardForm;
